import { useQuery } from '@tanstack/react-query';
import {
  getDigestConfig,
  getDiffSummary,
  getWatchlist,
  listDigestConfigs,
  listDigestRuns,
  listDigests,
} from '@/utils/digestAdminAPI';
import type {
  ListConfigsParams,
  ListDigestsParams,
  ListRunsParams,
} from '@/types/digestAdmin';

export function useDigestConfigs(params: ListConfigsParams = {}) {
  return useQuery({
    queryKey: ['digest-configs', params],
    queryFn: () => listDigestConfigs(params),
    staleTime: 60_000,
  });
}

export function useDigestConfig(id: string | undefined) {
  return useQuery({
    queryKey: ['digest-config', id],
    queryFn: () => getDigestConfig(id as string, ['sources', 'template', 'sender']),
    enabled: !!id,
    staleTime: 60_000,
  });
}

export function useDigestRuns(params: ListRunsParams = {}) {
  return useQuery({
    queryKey: ['digest-runs', params],
    queryFn: () => listDigestRuns(params),
    staleTime: 30_000,
  });
}

export function useDigests(params: ListDigestsParams = {}) {
  return useQuery({
    queryKey: ['digests', params],
    queryFn: () => listDigests(params),
    staleTime: 60_000,
  });
}

export function useDiffSummary(id: string | undefined | null) {
  return useQuery({
    queryKey: ['diff-summary', id],
    queryFn: () => getDiffSummary(id as string),
    enabled: !!id,
    staleTime: 5 * 60_000,
    retry: false, // don't pound the API if a diff has been deleted
  });
}

export function useWatchlist(id: string | undefined) {
  return useQuery({
    queryKey: ['watchlist', id],
    queryFn: () => getWatchlist(id as string, ['pages']),
    enabled: !!id,
    staleTime: 60_000,
  });
}
